<div class="wrapper-side-bar" [ngClass]="{ collapse: menuCollapse }">
  <div class="menu-header" *ngIf="menuCollapse">
    <img
      class="circle-mustach"
      (click)="toggleMenu()"
      *ngIf="!isVendorUser"
      src="./assets/img/arrow_forward.svg"
      alt="arrow-forward"
    />
  </div>
  <div class="menu-header" *ngIf="!menuCollapse">
    <div class="text-menu icon-logo-container">
      <!-- Rappi -->
      <div
        class="icon-logo"
        [ngClass]="!isVendorUser ? 'visible' : 'hidden'"
        (click)="home()"
      >
        <img
          *ngIf="!isVendorUser"
          src="./assets/img/rappi-turbo.svg"
          alt="logo"
          class="logo-turbo"
        />
      </div>
      <img
        class="arrow-icon"
        (click)="toggleMenu()"
        *ngIf="!isVendorUser"
        src="./assets/img/arrow_back.svg"
        alt="arrow-back"
      />
      <!-- Vendor-->
      <div
        class="icon-logo"
        [ngClass]="isVendorUser ? 'visible' : 'hidden'"
        (click)="home()"
      >
        <img
          *ngIf="isVendorUser"
          src="./assets/img/turbo-isotipo.svg"
          alt="turbo"
        />
        <img
          class="logo-turbo"
          *ngIf="isVendorUser"
          src="./assets/img/turbo-logotipo.svg"
          alt="turbo-fresh"
        />
      </div>
      <img
        class="arrow-icon"
        (click)="toggleMenu()"
        *ngIf="isVendorUser"
        src="./assets/img/arrow_back.svg"
        alt="arrow-back"
      />
    </div>
  </div>
  <div class="menu-body" [ngClass]="isVendorUser ? 'vendor' : ''">
    <div class="accordion accordion-flush" id="accordion">
      <div
        class="accordion-item"
        *ngFor="let mitem of menuModules; index as i"
        [appHasPermission]="mitem.role"
      >
        <h2 class="accordion-header">
          <button
            *ngIf="!mitem.link"
            class="accordion-button d-flex align-items-center"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + i"
            id="'#collapse-' + {{ i }}"
          >
            <i class="nav-icon" [ngClass]="mitem.icon"></i>
            <span>{{ mitem.text | async }}</span>
          </button>
          <a
            *ngIf="mitem.link"
            [routerLink]="mitem.link"
            class="accordion-button link d-flex align-items-center {{
              mitem.isNew ? 'is-new' : ''
            }}"
          >
            <i class="nav-icon" [ngClass]="mitem.icon"></i>
            <span>{{ mitem.text | async }}</span>
          </a>
        </h2>
        <div
          id="{{ 'collapse-' + i }}"
          class="accordion-collapse collapse {{ i === 0 ? 'show' : '' }}"
          data-bs-parent="#accordion"
        >
          <div class="accordion-body">
            <nav>
              <ul class="menu">
                <ng-container *ngFor="let item of mitem.items; index as j">
                  <li
                    class="menu-item"
                    [routerLink]="item.link"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: false }"
                    [appHasPermission]="item.role"
                    *ngIf="!item.subItems"
                  >
                    <a class="nav-link">
                      <i
                        class="nav-icon"
                        [ngClass]="item.icon"
                        id="cargo-nav-link-{{ j }}"
                      ></i>
                      <span class="menu-tooltip ng-star-inserted">{{
                        item.text | async
                      }}</span>
                      <span class="text-menu">
                        {{ item.text | async }}
                      </span>
                      <span *ngIf="item.isNew" class="ms-2 badge bg-secondary"
                        >New</span
                      >
                    </a>
                  </li>
                  <div
                    class="accordion accordion-flush"
                    id="accordion"
                    *ngIf="item.subItems"
                  >
                    <div class="accordion-item" id="accordion">
                      <li
                        class="menu-item"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: false }"
                        [appHasPermission]="item.role"
                        (click)="toggleDropdown(j)"
                      >
                        <a
                          class="nav-link"
                          style="
                            display: flex;
                            justify-content: space-between;
                            width: 100%;
                          "
                        >
                          <div>
                            <i
                              class="nav-icon"
                              [ngClass]="item.icon"
                              id="cargo-nav-link-{{ j }}"
                            ></i>
                            <span class="menu-tooltip ng-star-inserted">{{
                              item.text | async
                            }}</span>
                            <span class="text-menu">
                              {{ item.text | async }}
                            </span>
                          </div>
                          <i
                            class="sub-menu-up-{{ j }} bi bi-chevron-up"
                            id="cargo-nav-link-up-{{ j }}"
                            style="padding-right: 1.4rem"
                          ></i>
                          <i
                            class="sub-menu-down-{{ j }} bi bi-chevron-down"
                            id="cargo-nav-link-down-{{ j }}"
                            style="padding-right: 1.4rem"
                          ></i>
                        </a>
                      </li>
                      <div
                        class="dropdown-menu-payment-back-margins"
                        id="content-sub-items-{{ j }}"
                      >
                        <ul
                          class="menu"
                          *ngFor="let subItem of item.subItems; index as k"
                        >
                          <li
                            class="menu-item"
                            [routerLink]="subItem.link"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: false }"
                            [appHasPermission]="subItem.role"
                            style="padding-left: 55px"
                          >
                            <a class="nav-link">
                              <span class="menu-tooltip ng-star-inserted">{{
                                subItem.text | async
                              }}</span>
                              <span class="text-menu">
                                {{ subItem.text | async }}
                              </span>
                              <span
                                *ngIf="subItem.isNew"
                                class="ms-2 badge bg-secondary"
                                >New</span
                              >
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="menu-footer">
    <div class="">
      <nav>
        <ul class="menu">
          <li
            class="menu-item"
            *ngFor="let mitem of administrationMenu"
            [routerLink]="mitem.link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
            [appHasPermission]="mitem.role"
          >
            <a class="nav-link">
              <i
                class="nav-icon"
                [ngClass]="mitem.icon"
                id="cargo-nav-link-{{ mitem.text }}"
              ></i>
              <span class="menu-tooltip ng-star-inserted">{{
                mitem.text | async
              }}</span>
              <span class="text-menu">
                {{ mitem.text | async }}
              </span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="menu-logout pointer" (click)="logout()">
      <i class="nav-icon bi bi-box-arrow-right"></i>
      <span class="text-menu">
        {{ "DASHBOARD.VERTICAL_MENU.CLOSE_SESSION" | translate }}
      </span>
    </div>
  </div>
</div>
